// Modules
import { useFormContext } from "react-hook-form"

// Constants
import { PERK_TYPES } from "~constants/perks"
import { ERROR_MESSAGES } from "~constants/errorMessages"

// RBAC
import { RBAC_RULES } from "~rbac/constants/rbac-rules"
import IsAuthorized from "~rbac/isAuthorized"

// Utils
import { createDropdownCollection } from "~utils/dropdown"

// Components
import ControlSelect from "~app/ControlSelect"
import { WizardStepContainer } from "~styled/wizard"

// Shapes
import { CompanyShape } from "~shapes/company"
import { SelectOption } from "~utils/dropdown"

interface StepProps {
  companies: CompanyShape[]
  isLoading: boolean
  isVisible: boolean
  perkTypeDisabled: boolean
}

const PerkModalStep1 = (props: StepProps) => {
  const { formState: { errors }, control } = useFormContext()
  const {
    isVisible = true,
    companies,
    isLoading,
    perkTypeDisabled = false,
  } = props

  const createCompaniesDropdown = (): SelectOption[] => {
    const parsedCompanies = companies.map(c => ({ name: c.name, id: c.id }))
    return createDropdownCollection(parsedCompanies, "name", "id")
  }

  const createPerkTypesDropdown = (): SelectOption[] => {
    const parsedTypes = Object.keys(PERK_TYPES).map(k => ({
      id: k,
      name: PERK_TYPES[k],
    }))
    return createDropdownCollection(parsedTypes, "name", "id")
  }

  return (
    <WizardStepContainer className={isVisible ? "visible" : ""}>
      <IsAuthorized action={RBAC_RULES.UPDATE_PERK_COMPANY}>
        <ControlSelect
          name={"company"}
          label={"Company"}
          rules={{ required: true }}
          control={control}
          options={createCompaniesDropdown()}
          disabled={isLoading}
          isLoading={isLoading}
          errorMessage={errors.company && ERROR_MESSAGES.FIELD_REQUIRED}
        />
      </IsAuthorized>

      <ControlSelect
        name={"perkType"}
        label={"Perk type"}
        rules={{ required: true }}
        control={control}
        options={createPerkTypesDropdown()}
        disabled={perkTypeDisabled}
        searchable={false}
        errorMessage={errors.perkType && ERROR_MESSAGES.FIELD_REQUIRED}
      />
    </WizardStepContainer>
  )
}

export default PerkModalStep1
